var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"setSessionCategoryQuestion"}},[_vm._m(0),(this.sessionCategories.length > 0)?_c('div',{staticClass:"mb-4"},[_c('Dropdown',{attrs:{"value":this.formData.sessionCategory.sessionCategory,"options":_vm.sessionCategories},on:{"change":_vm.setSessionCategory}})],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_vm._v("Please confirm "),_c('strong',[_vm._v("what you require")])])
}]

export { render, staticRenderFns }